/** ค่าคงที่ที่ frontend และ backend ต้องเห็นตรงกัน */
export const QUESTION_TYPES = ['single', 'multiple', 'true_false', 'short_text'];
export const EXAM_KINDS = ['pretest', 'posttest', 'standalone'];
export const EXAM_STATUSES = ['draft', 'open', 'closed'];
export const ATTEMPT_STATUSES = ['in_progress', 'submitted', 'expired', 'abandoned'];
export const ADMIN_ROLES = ['admin', 'superadmin'];
export const COMPLETION_STATUSES = ['completed', 'pre_only', 'post_only', 'not_started'];
/** ผ่อนผันตอน submit เผื่อ network latency (วินาที) — ดู docs/04-scoring.md */
export const SUBMIT_GRACE_SECONDS = 30;
/** Auto-save — ดู docs/04-scoring.md */
export const AUTOSAVE_DEBOUNCE_MS = 2_000;
export const AUTOSAVE_FLUSH_INTERVAL_MS = 20_000;
export const AUTOSAVE_MAX_BACKOFF_MS = 30_000;
/** จำนวนผู้ทำขั้นต่ำก่อนจะแสดงค่าสถิติรายข้อ (อำนาจจำแนก) */
export const MIN_N_FOR_ITEM_ANALYSIS = 10;
/** เกณฑ์ตีความ normalized gain (Hake's g) */
export const GAIN_THRESHOLD_HIGH = 0.7;
export const GAIN_THRESHOLD_MEDIUM = 0.3;
/** จำนวนแถวสูงสุดที่รับได้ต่อการนำเข้ารายชื่อหนึ่งครั้ง */
export const INVITE_IMPORT_MAX_ROWS = 1000;
/** path หน้าเว็บของลิงก์ส่วนตัว — ประกอบเป็น URL เต็มที่ฝั่ง web */
export const INVITE_PATH_PREFIX = '/i/';
export const API_PREFIX = '/api/v1';
export const SESSION_TOKEN_HEADER = 'x-session-token';
export const ERROR_CODES = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED',
    INVALID_SESSION: 'INVALID_SESSION',
    FORBIDDEN: 'FORBIDDEN',
    EXAM_NOT_OPEN: 'EXAM_NOT_OPEN',
    EXAM_CLOSED: 'EXAM_CLOSED',
    EXAM_NOT_FOUND: 'EXAM_NOT_FOUND',
    INVITE_NOT_FOUND: 'INVITE_NOT_FOUND',
    NOT_FOUND: 'NOT_FOUND',
    ALREADY_SUBMITTED: 'ALREADY_SUBMITTED',
    MAX_ATTEMPTS_REACHED: 'MAX_ATTEMPTS_REACHED',
    EXAM_HAS_ATTEMPTS: 'EXAM_HAS_ATTEMPTS',
    DUPLICATE_ENTRY: 'DUPLICATE_ENTRY',
    ATTEMPT_EXPIRED: 'ATTEMPT_EXPIRED',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
/** HTTP status ประจำ error code แต่ละตัว — ดู docs/03-api.md */
export const ERROR_STATUS = {
    VALIDATION_ERROR: 400,
    UNAUTHORIZED: 401,
    INVALID_SESSION: 401,
    FORBIDDEN: 403,
    EXAM_NOT_OPEN: 403,
    EXAM_CLOSED: 403,
    EXAM_NOT_FOUND: 404,
    INVITE_NOT_FOUND: 404,
    NOT_FOUND: 404,
    ALREADY_SUBMITTED: 409,
    MAX_ATTEMPTS_REACHED: 409,
    EXAM_HAS_ATTEMPTS: 409,
    DUPLICATE_ENTRY: 409,
    ATTEMPT_EXPIRED: 410,
    RATE_LIMITED: 429,
    INTERNAL_ERROR: 500,
};
/** ข้อความภาษาไทยประจำ error code — ผู้เรียนเห็นข้อความนี้ตรงๆ */
export const ERROR_MESSAGES_TH = {
    VALIDATION_ERROR: 'ข้อมูลที่ส่งมาไม่ถูกต้อง',
    UNAUTHORIZED: 'กรุณาเข้าสู่ระบบ',
    INVALID_SESSION: 'เซสชันไม่ถูกต้องหรือหมดอายุแล้ว',
    FORBIDDEN: 'ไม่มีสิทธิ์เข้าถึง',
    EXAM_NOT_OPEN: 'แบบทดสอบนี้ยังไม่เปิดให้ทำ',
    EXAM_CLOSED: 'แบบทดสอบนี้ปิดรับคำตอบแล้ว',
    EXAM_NOT_FOUND: 'ไม่พบแบบทดสอบที่ต้องการ',
    INVITE_NOT_FOUND: 'ลิงก์ส่วนตัวนี้ใช้ไม่ได้แล้ว อาจถูกยกเลิกหรือสร้างใหม่ กรุณาติดต่อผู้จัดอบรม',
    NOT_FOUND: 'ไม่พบข้อมูลที่ต้องการ',
    ALREADY_SUBMITTED: 'ท่านได้ส่งคำตอบไปแล้ว',
    MAX_ATTEMPTS_REACHED: 'ท่านทำแบบทดสอบครบจำนวนครั้งที่กำหนดแล้ว',
    EXAM_HAS_ATTEMPTS: 'แก้ไขไม่ได้ เพราะมีผู้ทำแบบทดสอบชุดนี้แล้ว',
    DUPLICATE_ENTRY: 'มีข้อมูลนี้อยู่แล้ว',
    ATTEMPT_EXPIRED: 'หมดเวลาทำแบบทดสอบแล้ว',
    RATE_LIMITED: 'มีคำขอถี่เกินไป กรุณารอสักครู่แล้วลองใหม่',
    INTERNAL_ERROR: 'เกิดข้อผิดพลาดในระบบ กรุณาลองใหม่อีกครั้ง',
};
/** จำนวนคนทำครบทั้งคู่ขั้นต่ำ ก่อนที่ตัวเลขสรุปจะเชื่อถือได้ — ต่ำกว่านี้ต้องขึ้นแบนเนอร์เตือน */
export const LOW_SAMPLE_WARNING_N = 10;
/** เปรียบเทียบข้ามรอบอบรมได้ครั้งละไม่เกินกี่หลักสูตร — มากกว่านี้ตารางและกราฟอ่านไม่ออกบนจอแอดมิน */
export const MAX_COMPARE_COURSES = 6;
/** ความกว้างของ bin ใน histogram คะแนน (%) — ดู docs/06-dashboard.md */
export const SCORE_BIN_SIZE = 10;
/** ใช้เวลาน้อยกว่า 20% ของค่ามัธยฐาน = น่าสงสัยว่ากดมั่ว */
export const SUSPICIOUS_DURATION_RATIO = 0.2;
/** Live monitor: ไม่มีการบันทึกคำตอบเกินเท่านี้ = อาจเน็ตหลุด (วินาที) */
export const LIVE_STALE_SECONDS = 180;
/** Live monitor: ความถี่ที่หน้าเว็บ poll (มิลลิวินาที) */
export const LIVE_POLL_INTERVAL_MS = 15_000;
//# sourceMappingURL=constants.js.map